import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Styled from './BackgroundPaper.styled';

const BackgroundPaper = (props) => {
  const { children, classes, className } = props;
  return (
    <Styled.Container className={classnames(classes.root, className)}>
      {children}
    </Styled.Container>
  );
};

BackgroundPaper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  className: PropTypes.string,
  classes: PropTypes.object,
};

BackgroundPaper.defaultProps = {
  classes: {},
  children: null,
  className: '',
};

export default BackgroundPaper;
